import React from "react";
import { useI18n } from "../i18n/I18nContext";

const SECTIONS = {
  en: [
    { h: "Your account", b: "You're responsible for keeping your account secure and the information accurate. Don't share your password." },
    { h: "Purchases", b: "Each guide is a digital product. You receive a download link by email after payment is confirmed. Prices are shown at checkout in your local currency." },
    { h: "Refunds", b: "Because guides are delivered immediately, all sales are final. If something is broken or you can't access your purchase, write to hello@thelifeplot.com — we'll make it right." },
    { h: "Licence", b: "When you buy a guide, you receive a personal, non-transferable licence to use it. Please don't resell, redistribute, or upload our PDFs elsewhere." },
    { h: "Liability", b: "Our guides are not medical, legal, or financial advice. They're practical action plans. You're responsible for your own decisions and outcomes." },
    { h: "Changes", b: "We may update these terms. We'll let you know via email if changes affect your account. Continuing to use The Life Plot after that means you accept the updated terms." },
  ],
  ro: [
    { h: "Contul tău", b: "Ești responsabil să-ți păstrezi contul în siguranță și informațiile actualizate. Nu împărtăși parola." },
    { h: "Cumpărături", b: "Fiecare ghid este un produs digital. Primești linkul de descărcare pe email după confirmarea plății. Prețurile sunt afișate la checkout în moneda ta locală." },
    { h: "Rambursări", b: "Deoarece ghidurile se livrează imediat, toate vânzările sunt finale. Dacă ceva este stricat sau nu poți accesa achiziția, scrie-ne la hello@thelifeplot.com — rezolvăm." },
    { h: "Licență", b: "Când cumperi un ghid, primești o licență personală, netransferabilă, de utilizare. Te rugăm să nu revinzi, redistribui sau încarci PDF-urile noastre în altă parte." },
    { h: "Răspundere", b: "Ghidurile noastre nu sunt sfat medical, juridic sau financiar. Sunt planuri practice de acțiune. Tu ești responsabil pentru deciziile și rezultatele tale." },
    { h: "Modificări", b: "Putem actualiza acești termeni. Te vom anunța prin email dacă modificările îți afectează contul. Continuarea utilizării The Life Plot înseamnă acceptarea termenilor actualizați." },
  ],
};

export default function Terms() {
  const { t, lang } = useI18n();
  const items = SECTIONS[lang];
  return (
    <article className="container py-16 md:py-24 max-w-3xl">
      <p className="font-mono-label text-gold/80 mb-4">
        {t.legal.updated} · {new Date().toLocaleDateString(lang === "ro" ? "ro-RO" : "en-US", { year: "numeric", month: "long" })}
      </p>
      <h1 className="font-display text-section md:text-section-lg tracking-tight leading-[1.05]">{t.legal.termsTitle}</h1>
      <p className="mt-6 ed-italic text-subtitle text-cream-muted">{t.legal.termsIntro}</p>
      <div className="divider-fade my-12" />
      <div className="space-y-12">
        {items.map((s, i) => (
          <section key={i}>
            <h2 className="font-display text-card-lg tracking-tight">{s.h}</h2>
            <p className="mt-4 text-cream-muted text-body leading-relaxed">{s.b}</p>
          </section>
        ))}
        <section>
          <p className="text-small text-cream-muted">
            {lang === "en" ? "Contact: " : "Contact: "}
            <a href="mailto:hello@thelifeplot.com" className="text-gold hover:text-gold-hover">hello@thelifeplot.com</a>
          </p>
        </section>
      </div>
    </article>
  );
}
